
export const adLinks = [
  { id: '1', label: 'Crear aviso', route: '/careers/new-oportunity' },
  { id: '2', label: 'Gestionar avisos', route: '/careers/oportunities' },
  { id: '3', label: 'Ver postulantes', route: '/careers/handle-applications' },
]

export const filterSvg = {
  d: 'M10.9259 17.6432H17.5926C18.0174 17.6437 18.4259 17.8064 18.7348 18.098C19.0437 18.3896 19.2296 18.7882 19.2545 19.2122C19.2794 19.6363 19.1414 20.0539 18.8688 20.3796C18.5961 20.7054 18.2094 20.9147 17.7876 20.9649L17.5926 20.9766H10.9259C10.5011 20.9761 10.0925 20.8134 9.78361 20.5218C9.47471 20.2302 9.28883 19.8316 9.26393 19.4076C9.23904 18.9835 9.37701 18.5659 9.64966 18.2402C9.92231 17.9144 10.3091 17.7051 10.7309 17.6549L10.9259 17.6432ZM7.59255 9.3099H20.9259C21.3507 9.31037 21.7593 9.47303 22.0682 9.76464C22.3771 10.0563 22.5629 10.4548 22.5878 10.8789C22.6127 11.303 22.4748 11.7205 22.2021 12.0463C21.9295 12.372 21.5427 12.5814 21.1209 12.6316L20.9259 12.6432H7.59255C7.16776 12.6428 6.75917 12.4801 6.45027 12.1885C6.14138 11.8969 5.9555 11.4983 5.9306 11.0742C5.90571 10.6502 6.04368 10.2326 6.31633 9.90684C6.58898 9.58109 6.97573 9.37174 7.39755 9.32156L7.59255 9.3099ZM2.59255 0.976562H25.9259C26.3507 0.977034 26.7593 1.13969 27.0682 1.43131C27.3771 1.72292 27.5629 2.12148 27.5878 2.54555C27.6127 2.96962 27.4748 3.38719 27.2021 3.71295C26.9295 4.03871 26.5427 4.24806 26.1209 4.29823L25.9259 4.3099H2.59255C2.16775 4.30942 1.75917 4.14676 1.45027 3.85515C1.14138 3.56353 0.955496 3.16497 0.930601 2.7409C0.905706 2.31683 1.04368 1.89926 1.31633 1.57351C1.58898 1.24775 1.97573 1.0384 2.39755 0.988229L2.59255 0.976562Z',
  fill: '#004876',
}

export const jobAdsFields = [
  {
    name: 'CUE',
    id: 'cue',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: true,
    input: 'select',
    section: 'institution',
    required: true,
    length: null,
    order: 1,
    width: null,
  },
  {
    name: 'Nro de referencia',
    id: 'referenceNumber',
    type: 'number',
    isShown: true,
    isEdited: true,
    isFiltered: true,
    input: 'number',
    section: 'ad',
    required: true,
    length: null,
    order: 21,
    tableOrder: 1,
    width: 10,
  },
  {
    name: 'Institución',
    id: 'institution',
    type: 'text',
    isShown: true,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'institution',
    required: true,
    length: null,
    order: 2,
    tableOrder: 2,
    width: 15,
  },
  {
    name: 'Nivel',
    id: 'level',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'institution',
    required: true,
    length: null,
    order: 3,
    width: null,
  },
  {
    name: 'Característica',
    id: 'levelModalities',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'institution',
    required: false,
    length: null,
    order: 5,
    width: null,
  },
  {
    name: 'Modalidad',
    id: 'institutionTypes',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'institution',
    required: true,
    length: null,
    order: 6,
    width: null,
  },
  {
    name: 'Estado',
    id: 'state',
    type: 'text',
    isShown: true,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'state',
    required: true,
    length: null,
    order: 5,
    tableOrder: 3,
    width: 10,
  },

  {
    name: 'Fecha de creación',
    id: 'creationDate',
    type: 'text',
    isShown: true,
    isEdited: true,
    isFiltered: false,
    input: 'date',
    section: 'ad',
    required: false,
    length: null,
    order: 22,
    tableOrder: 4,
    width: 12,
  },
  {
    name: 'Título',
    id: 'title',
    type: 'text',
    isShown: true,
    isEdited: true,
    isFiltered: true,
    input: 'text',
    section: 'ad',
    required: true,
    length: null,
    order: 7,
    tableOrder: 5,
    width: 28,
  },
  {
    name: 'Fecha de publicación',
    id: 'publicationDate',
    type: 'text',
    isShown: true,
    isEdited: true,
    isFiltered: false,
    input: 'date',
    section: 'ad',
    required: false,
    length: null,
    order: 23,
    tableOrder: 6,
    width: 12,
  },
  {
    name: 'Fecha de vencimiento',
    id: 'expirationDate',
    type: 'text',
    isShown: true,
    isEdited: true,
    isFiltered: false,
    input: 'date',
    section: 'ad',
    required: false,
    length: null,
    order: 24,
    tableOrder: 7,
    width: 12,
  },
  {
    name: 'Provincia - Departamento/Partido - Localidad',
    id: 'address',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'institution',
    required: true,
    length: null,
    order: 4,

    width: null,
  },
  {
    name: 'Vacantes disponibles',
    id: 'vacancies',
    type: 'number',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'ad',
    required: false,
    length: null,
    order: 17,
    width: null,
  },
  {
    name: 'Cantidad de horas',
    id: 'hours',
    type: 'number',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'ad',
    required: false,
    length: null,
    order: 10,
    width: null,
  },
  {
    name: 'Tipo de cargo',
    id: 'positionType',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: true,
    input: 'select',
    section: 'ad',
    required: true,
    length: null,
    order: 8,
    width: null,
  },
  {
    name: 'Puesto de trabajo',
    id: 'position',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: true,
    input: 'select',
    section: 'ad',
    required: true,
    length: null,
    order: 9,
    width: null,
  },
  {
    name: 'Disponibilidad',
    id: 'availability',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'select',
    section: 'ad',
    required: false,
    length: null,
    order: 13,
    width: null,
  },
  {
    name: 'Franja horaria',
    id: 'timePeriod',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'multipleSelect',
    section: 'ad',
    required: false,
    length: null,
    order: 16,
    width: null,
  },
  {
    name: 'Tipo de área',
    id: 'areaType',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'select',
    section: 'ad',
    required: false,
    length: null,
    order: 11,
    width: null,
  },
  {
    name: 'Área',
    id: 'area',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'select',
    section: 'ad',
    required: false,
    length: null,
    order: 12,
    width: null,
  },
  {
    name: 'Experiencia laboral solicitada',
    id: 'jobExperience',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'ad',
    required: false,
    length: 500,
    order: 20,
    width: null,
  },
  {
    name: 'Modalidad del trabajo',
    id: 'modality',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'select',
    section: 'ad',
    required: false,
    length: null,
    order: 15,
    width: null,
  },
  {
    name: 'Suplencias',
    id: 'suplencies',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'multipleSelect',
    section: 'ad',
    required: false,
    length: null,
    order: 14,
    width: null,
  },
  {
    name: 'Tareas requeridas',
    id: 'tasks',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'ad',
    required: false,
    length: 2500,
    order: 18,
    width: null,
  },
  {
    name: 'Habilidades blandas',
    id: 'softSkills',
    type: 'text',
    isShown: false,
    isEdited: true,
    isFiltered: false,
    input: 'text',
    section: 'ad',
    required: false,
    length: 500,
    order: 19,
    width: null,
  },
]

export const newJobAdFields = [
  {
    name: 'CUE',
    id: 'cue',
    type: 'text',
    order: 1,
    section: 'institution',
    length: null,
    input: 'text',
    required: true,
  },
  {
    name: 'Institución',
    id: 'institution',
    type: 'text',
    order: 2,
    section: 'institution',
    length: null,
    input: 'text',
    required: true,
  },
  {
    name: 'Nivel',
    id: 'level',
    type: 'text',
    order: 3,
    section: 'institution',
    length: null,
    input: 'multipleSelect',
    required: true,
  },

  {
    name: 'Provincia - Departamento/Partido - Localidad',
    id: 'address',
    type: 'text',
    order: 4,
    section: 'institution',
    length: null,
    input: 'select',
    required: true,
  },
  {
    name: 'Modalidad',
    id: 'institutionTypes',
    type: 'text',
    order: 6,
    section: 'institution',
    length: null,
    input: 'select',
    required: true,
  },
  {
    name: 'Característica',
    id: 'levelModalities',
    type: 'text',
    order: 5,
    section: 'institution',
    length: null,
    input: 'select',
    required: false,
  },
  {
    name: 'Título del aviso',
    id: 'title',
    type: 'text',
    order: 6,
    section: 'ad',
    length: 50,
    input: 'text',
    required: true,
  },

  {
    name: 'Fecha de publicación',
    id: 'publicationDate',
    type: 'text',
    order: 20,
    section: 'ad',
    length: null,
    input: 'date',
    required: false,
  },

  {
    name: 'Fecha de vencimiento',
    id: 'expirationDate',
    type: 'text',
    order: 21,
    section: 'ad',
    length: null,
    input: 'date',
    required: false,
  },

  {
    name: 'Vacantes disponibles',
    id: 'vacancies',
    type: 'number',
    order: 16,
    section: 'ad',
    length: null,
    input: 'text',
    required: false,
  },
  {
    name: 'Cantidad de horas',
    id: 'hours',
    type: 'number',
    order: 9,
    section: 'ad',
    length: null,
    input: 'text',
    required: false,
  },
  {
    name: 'Tipo de cargo',
    id: 'positionType',
    type: 'text',
    order: 7,
    section: 'ad',
    length: null,
    input: 'select',
    required: true,
  },
  {
    name: 'Puesto de trabajo',
    id: 'position',
    type: 'text',
    order: 8,
    section: 'ad',
    length: null,
    input: 'select',
    required: true,
  },
  {
    name: 'Disponibilidad',
    id: 'availability',
    type: 'text',
    order: 12,
    section: 'ad',
    length: null,
    input: 'multipleSelect',
    required: false,
  },
  {
    name: 'Franja horaria',
    id: 'timePeriod',
    type: 'text',
    order: 15,
    section: 'ad',
    length: null,
    input: 'multipleSelect',
    required: false,
  },
  {
    name: 'Tipo de área',
    id: 'areaType',
    type: 'text',
    order: 10,
    section: 'ad',
    length: null,
    input: 'select',
    required: false,
  },
  {
    name: 'Área',
    id: 'area',
    type: 'text',
    order: 11,
    section: 'ad',
    length: null,
    input: 'select',
    required: false,
  },
  {
    name: 'Experiencia laboral solicitada',
    id: 'jobExperience',
    type: 'text',
    order: 19,
    section: 'ad',
    length: 500,
    input: 'text',
    required: false,
  },
  {
    name: 'Modalidad del trabajo',
    id: 'modality',
    type: 'text',
    order: 14,
    section: 'ad',
    length: null,
    input: 'select',
    required: false,
  },
  {
    name: 'Suplencias',
    id: 'suplencies',
    type: 'text',
    order: 13,
    section: 'ad',
    length: null,
    input: 'multipleSelect',
    required: false,
  },
  {
    name: 'Tareas requeridas',
    id: 'tasks',
    type: 'text',
    order: 17,
    section: 'ad',
    length: 2500,
    input: 'text',
    required: false,
  },
  {
    name: 'Habilidades blandas',
    id: 'softSkills',
    type: 'text',
    order: 18,
    section: 'ad',
    length: 500,
    input: 'text',
    required: false,
  },
]

export const availabilityOptions = [
  { value: 'lunes', label: 'Lunes' },
  { value: 'martes', label: 'Martes' },
  { value: 'miércoles', label: 'Miércoles' },
  { value: 'jueves', label: 'Jueves' },
  { value: 'viernes', label: 'Viernes' },
  { value: 'sabado', label: 'Sábado' },
  { value: 'domingo', label: 'Domingo' },
  { value: 'lunes-viernes', label: 'Lunes a Viernes' },
]

export const positionTypeOptions = [
  { value: 'DOCENTE', label: 'Docente' },
  { value: 'NO DOCENTE', label: 'No Docente' },
]

export const transformDate = (date: any) => {
  return new Date(date).toISOString().split('T')[0].split('-').reverse().join('/')
}
